var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEditIcon = function SvgEditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 51239"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 20877",
    width: 40,
    height: 40,
    rx: 20,
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "edit icon",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon feather-edit-2",
    d: "M24.062 12.742a2.263 2.263 0 1 1 3.2 3.2L16.473 26.723l-4.393 1.2 1.2-4.4Z",
    stroke: "#95dbd5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 21075",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgEditIcon;